import type { Shape } from "@/telestrations/types/canvas";
import { getEllipseUpdate } from "@/telestrations/helpers/getEllipseUpdate";
import { getRectangleUpdate } from "@/telestrations/helpers/getRectangleUpdate";
import { ShapeType } from "@/telestrations/types/canvas";

type ShapeUpdateFn = (params: { shape: Shape; pointer: { x: number; y: number }; shift: boolean; offset: { x: number; y: number } }) => Partial<Shape>;

export const shapeUpdateStrategies: Partial<Record<ShapeType, ShapeUpdateFn>> = {
  [ShapeType.Ellipse]: ({ shape, pointer, shift, offset }) =>
    getEllipseUpdate({
      shape,
      pointer,
      isCircle: shift,
      offset,
    }),
  [ShapeType.Rectangle]: ({ shape, pointer, shift, offset }) =>
    getRectangleUpdate({
      shape,
      pointer,
      isSquare: shift,
      offset,
    }),
  [ShapeType.Spotlight]: ({ shape, pointer, shift, offset }) =>
    getEllipseUpdate({
      shape,
      pointer,
      isCircle: shift,
      offset,
    }),
};
